<template>
  <v-app-bar
    color="neutral0" height="64"
    flat
    scroll-behavior="hide"
  >
    <BrandButton variant="basic" class="mr-4" to="/">
      <PhArrowLeft class="text-h5 mr-2" />
      {{ t('cta.back') }}
    </BrandButton>

    <v-spacer />

    <NewsButton short />

    <BrandButton
      variant="secondary" class="ml-2 mr-4"
      target="_blank" :href="extAppUrl"
    >
      <PhArrowsOutSimple class="text-h5 mr-2" />
      {{ t('cta.full_page') }}
    </BrandButton>

    <AppBarUser v-if="user" :user="user" />
  </v-app-bar>
</template>

<script>
import { ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import { PhArrowsOutSimple, PhArrowLeft } from '@phosphor-icons/vue'
import NewsButton from '@/components/NewsButton.vue'
import getBrowser from '@/plugins/browser-polyfill'
import AppBarUser from './AppBarUser.vue'

export default {
  components: {
    AppBarUser,
    PhArrowsOutSimple,
    PhArrowLeft,
    NewsButton,
  },
  setup() {
    const store = useStore()
    const { t } = useI18n()
    const extAppUrl = ref(null)

    const user = computed(() => store.getters['auth/session'])

    onMounted(async () => {
      if (BUILD_TARGET === 'extension') {
        extAppUrl.value = (await getBrowser()).runtime.getURL('index.html')
      }
    })

    return {
      t,
      user,
      extAppUrl
    }
  }
}
</script>

<style lang="scss" scoped>
.v-app-bar {
  border-bottom: 1px solid rgb(var(--v-theme-neutral50)) !important;
}
</style>
